// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cCAWiZ50V6DfqGp65xQG","editor":"bWMghy7ECFZCR03BUuuA","textarea":"Tn1JWoMNXjlKk9Nac6jQ"};